import React from 'react';
import PropTypes from 'prop-types';

import format from 'date-fns/format';

import {
    StyledTourCardDetailsText,
} from './StyledComponents';

const propTypes = {
    tour: PropTypes.shape({
        name: PropTypes.string.isRequired,
        createdDate: PropTypes.string.isRequired,
        creatorName: PropTypes.string.isRequired,
        imageSrc: PropTypes.string,
        state: PropTypes.oneOf(['active', 'inactive', 'empty']),
    }).isRequired,
};

const TourCardDetails = ({
    tour,
}) => (
    <div>
        <StyledTourCardDetailsText as="div" fontType="bodyHeading">
            {tour.name || 'No tour name'}
        </StyledTourCardDetailsText>
        <StyledTourCardDetailsText as="div" fontType="bodySmall">
            {`Created ${format(new Date(tour.createdDate), 'MM/DD/YYYY')}`}
        </StyledTourCardDetailsText>
        {false && (
            <StyledTourCardDetailsText as="div" paddingBottom="xs" fontType="bodySmall">
                {`By ${tour.creatorName || 'unknown'}`}
            </StyledTourCardDetailsText>
        )}
    </div>
);

TourCardDetails.propTypes = propTypes;

export default TourCardDetails;
